import * as React from 'react';
import {connect} from 'react-redux';
import DataTable from "../DataTable";
import {Button, Modal} from "react-bootstrap";
import moment from "moment";
import ReactDOM from "react-dom";
import {GetURIByParts} from "../../services/Utils/StringUtils";
import VendorEditForm from "./VendorEditForm";
import {IVendors} from "./business-objects/common";
import {getAllVendors, saveNewVendors, saveUpdatedVendors, getAllAgencies} from "./redux-objects/actions";
import CommentModal from '../CommentModal/CommentModal';
import { addVendorLog } from './logging/auditLog';
import { UserInfo } from '../Login/common/defaults';


export interface IVendorActionProps {
    getAllAgencies: (url:string) => void;
    getAllVendors: (url: string) => void;
    saveUpdatedVendor: (url: string, vendor: IVendors) => void;
    saveNewVendor: (url: string, vendor: IVendors) => void;
}

interface IVendorStateProps {
    vendors: IVendors[];
    webServiceURL: string;
    isProcessing: boolean;
    currentUser: UserInfo;
    elasticSearchURL: string;
}

interface IVendorsProps
    extends IVendorActionProps,
        IVendorStateProps {
}

interface IVendorState {
    userOnlyFiler: boolean;
    activeFilter: boolean;
    showModal: boolean;
    modalStatus: ModalMode;
    currentVendor: IVendors;
    showCommentModal: boolean;
    comment: string;
    pendingAction: string;
}

enum ModalMode {
    None,
    New,
    Editing
}

enum ServiceEndPoints {
    AllActiveVendors = 'VendorList',
    CreateVendor = 'CreateVendor',
    UpdateVendor = 'EditVendor',
    GetAllAgencies = 'AgencyList'
}

class Vendors extends React.Component<IVendorsProps, IVendorState> {
    private editForm: any = React.createRef();

    state = {
        userOnlyFiler: true,
        activeFilter: true,
        showModal: false,
        modalStatus: ModalMode.None,
        currentVendor: null,
        showCommentModal: false,
        comment: '',
        pendingAction: ''
    };

    private vendorServiceController: string =
        'Vendor';

    componentDidMount = () => {
        let uri = GetURIByParts(
            this.props.webServiceURL,
            this.vendorServiceController,
            ServiceEndPoints.AllActiveVendors
        );

        (async() => {
            await this.props.getAllVendors(uri);
            await this.props.getAllAgencies(GetURIByParts(this.props.webServiceURL, this.vendorServiceController, ServiceEndPoints.GetAllAgencies));
        })();
    };

    // handleChange = (changed: CustomEvent) => {
    //     //console.log('Change log: ', changed);
    // };
    handleChange = (e: React.FormEvent) => {
        let el: HTMLFormElement = e.currentTarget as HTMLFormElement;    
        switch (el.dataset.field) {
          case 'comment':
            this.setState({
              comment: el.value
            });
            break;
          default:
            break;
        }
      };

    editVendor = e => {
        let currVendor: IVendors = this.props.vendors.find(
            vendor =>
                vendor.id ==
                parseInt(((e as Event).currentTarget as HTMLButtonElement).value)
        );
        this.toggleScrollLock();
        this.setState({
            modalStatus: ModalMode.Editing,
            showModal: true,
            currentVendor: currVendor
        });
    };

    createNewVendor = e => {
        this.toggleScrollLock();
        this.setState({
            modalStatus: ModalMode.New,
            showModal: true,
            currentVendor: null
        });
    };

    closeModel = () => {
        this.toggleScrollLock();
        this.setState({
            showCommentModal: false,
            pendingAction: '',
            modalStatus: ModalMode.None,
            showModal: false,
            currentVendor: null
        });
    };

    toggleScrollLock = () => {
        document.querySelector('html').classList.toggle('scroll-lock');
    };

    onSaveVendor = () => {
        this.setState({
            pendingAction: 'updateVendor',
            showCommentModal: true
          });
    }

    cancelComment = () => {
        this.setState({
          comment: '',
          showCommentModal: false
        });
      };
    
    saveComment = () => {
        if (this.state.pendingAction == 'updateVendor') this.doSaveVendor();
    };

    doSaveVendor = async () => {
        let updatedVendor = this.editForm.getUpdatedVendor();
        updatedVendor.active = true;

        if(updatedVendor.id == undefined) {
            this.props.saveNewVendor(GetURIByParts(this.props.webServiceURL, this.vendorServiceController, ServiceEndPoints.CreateVendor), updatedVendor)
        } else {            
            this.props.saveUpdatedVendor(GetURIByParts(this.props.webServiceURL, this.vendorServiceController, ServiceEndPoints.UpdateVendor), updatedVendor);
        }
        //Audit Logging
        const action = updatedVendor.id == undefined ? 'Added ' : 'Updated ' + ' Vendor';
        const desc = updatedVendor.id == undefined
          ? 'Added ' +
            updatedVendor.name
          : 'Edited ' +
            updatedVendor.name;
        const detailData = updatedVendor;
        addVendorLog(
          this.props.elasticSearchURL,
          action,
          desc,
          this.props.currentUser.username,
            this.state.comment,
          detailData
        );

        this.closeModel();
    };

    render() {
        const columnDefs = [
            {
                targets: 4,
                render: (data: moment.MomentInput) =>
                    moment(data).format('MMMM Do YYYY')
            },
            {
                targets: 0,
                createdCell: (td: Element, cellData: any) => {
                    return ReactDOM.render(
                        <button
                            className={'btn btn-outline-warning'}
                            value={cellData}
                            data-id={cellData}
                            onClick={this.editVendor}
                        >
                            Edit Vendor
                        </button>,
                        td
                    );
                }
            }
        ];

        const columns = [
            {
                title: 'Edit Vendor',
                data: 'id'
            },
            {
                title: 'Vendor',
                data: 'name'
            },
            {
                title: 'Description',
                data: 'description'
            },
            {
                title: 'Vendor Key Id',
                data: 'vendorKeyId'
            },
            {
                title: 'Created Date',
                data: 'createdDate'
            },
        ];

        const options = {
            className: 'table table-striped table-bordered'
        };

        return (
            <div id="divVendorList">
                <br>
                </br>
                <h3>Vendors</h3>
                <a href="#" onClick={this.createNewVendor}>
                    Create New Vendor
                </a>
                <DataTable
                    id="tblVendor"
                    //data={Array.isArray(this.props.vendors) ? this.props.vendors.filter(item => item.active == true) : []}
                    data={this.props.vendors}
                    columns={columns}
                    columnDefs={columnDefs}
                    {...options}
                />
                <Modal
                    show={this.state.showModal}
                    onHide={this.closeModel}
                    dialogClassName="modal-vendor-edit"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {' '}
                            {this.state.modalStatus == ModalMode.New
                                ? 'Add Vendor '
                                : 'Edit Vendor'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <VendorEditForm
                            vendorToEdit={this.state.currentVendor}
                            ref={ef => (this.editForm = ef)}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.closeModel}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={this.onSaveVendor}>
                            Save Changes
                        </Button>
                    </Modal.Footer>
                </Modal>
                <CommentModal
                    comment={this.state.comment}
                    show={this.state.showCommentModal}
                    onCommentChange={this.handleChange}
                    onCloseCommentModal={this.cancelComment}
                    onCancel={this.cancelComment}
                    onSave={this.saveComment}
                />
            </div>
        );
    }
}

const mapStateToProps = (reduxState: any) => {
    return {
        appUrl: reduxState.Application.backendURL,
        vendors: reduxState.Vendors.allVendors,
        webServiceURL: reduxState.Application.backendURL,
        isProcessing: reduxState.Vendors.isProcessing,
        elasticSearchURL: reduxState.Application.elasticSearchURL,
        currentUser: reduxState.Application.currentUser
    };
};

const mapDispatchToProps = {
    getAllAgencies,
    getAllVendors,
    saveNewVendor: saveNewVendors,
    saveUpdatedVendor: saveUpdatedVendors
};

export default connect<any>(mapStateToProps, mapDispatchToProps)(Vendors);
